module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kansai-10-6c15cc41c5f5d0ffec2e0ff545baa22f.png";